import { Invite, Repository, Team } from '@basehub/data/replicache/index'
import { type ServerLoggedInSessionSerializable } from '../../../auth/get-server-auth'
import { isUserRole } from './team/auth'
import { getURL } from '@basehub/shared-constants'

const inviteDuration = 1000 * 60 * 60 * 24 * 7 // 7 days

export const isInviteGeneric = (invite: Invite) => {
  return invite.userIdLock === null && invite.emailLock === null
}

export const isInviteExpired = (invite: Invite) => {
  if (isInviteGeneric(invite)) return false // generic invites never expire
  if (invite.useCount >= 1) return true
  const createdAt = new Date(invite.createdAt).getTime()
  return Date.now() - createdAt > inviteDuration
}

export const getInviteLink = (inviteToken: string) => {
  return `${getURL(
    'app',
    // @ts-ignore
    process.env.ENVIRONMENT || process.env.NEXT_PUBLIC_ENVIRONMENT
  )}/join?invite-token=${inviteToken}`
}

export type InviteStatus =
  | 'not-logged-in'
  | 'user-already-member'
  | 'expired'
  | 'user-lock-mismatch'
  | 'email-lock-mismatch'
  | 'valid'

export const checkInviteValidity = ({
  session,
  invite,
  ...rest
}: {
  session: ServerLoggedInSessionSerializable | null
  invite: Invite
} & (
  | {
      team: Team
    }
  | { repo: Repository }
)) => {
  let status: InviteStatus = 'valid'

  if (session) {
    if (
      ('team' in rest &&
        isUserRole({
          team: rest.team,
          userId: session.userId,
          roles: ['member', 'owner', 'editor', 'viewer'],
        })) ||
      ('repo' in rest &&
        rest.repo.guests?.list.some((guest) => guest.userId === session.userId))
    ) {
      status = 'user-already-member'
    } else if (invite.userIdLock && invite.userIdLock !== session.userId) {
      status = 'user-lock-mismatch'
    } else if (
      invite.emailLock &&
      invite.emailLock.toLowerCase() !==
        session.sessionClaims.email.toLowerCase()
    ) {
      status = 'email-lock-mismatch'
    }
  } else {
    status = 'not-logged-in'
  }

  if (isInviteExpired(invite)) {
    status = 'expired'
  }

  return status
}
